// extracted by mini-css-extract-plugin
export default {"horizontal-scroll":"shared_horizontal-scroll__kEn+s","sticky-header":"shared_sticky-header__gxcz9"};